export const techAndMeasures = {
  categories: {
    wastewater: 'Wastewater',
    energy: 'Energy',
    water: 'Water',
    energyAndWater: 'Energy & Water'
  },
  allProjects: {
    title: 'All Projects'
  },
  topProjects: {
    title: 'Top Projects'
  },
  quickWins: {
    title: 'Quick Wins'
  },
  measure: 'Measure',
  type: 'Type',
  category: 'Category',
  estimatedInvestment: 'Estimated investment expenditure',
  estimatedOperational: 'Estimated operational expenditure',
  traditionalTechnologyDesc: 'Traditional technology description',
  mainBenefitsOfBestAvailableTechnology: 'Main benefits of best available technology',
  resourceReductionProposedTechnology:
    'Resource reduction of proposed technology vs traditional technology',
  bestAvailableTechnologyInfo: 'Best available technology manufacturers information',
  description: 'Description',
  bestAvailableTechnologyDescription: 'Best available technology description',
  caseStudy: 'Case study',
  resourceReduction: 'Resource reduction',
  limitations: 'Limitations',
  implementationDifficulty: 'Implementation difficulty',
  potentialChemicalSuppliers: 'Potential Chemical Suppliers',
  avoidanceOfStandardizedWashOffAfterContinuousPrinting:
    'Avoidance of standarized washoff after continuous printing',
  optimizationOfExhaustDyeingMachineCapacity: 'optimization of exhaust dyeing machine capacity',
  adequateProductionPlanning: 'adequate production planning',
  avoidanceOfBleachingInDarkShades: 'avoidance of bleaching in darkshades',
  centrifugationAfterGarmentDyeingWithReactiveDyes:
    'centrifugation after garment dyeing with reactive dyes',
  installationOfHandTriggersAtWaterHoses: 'installation of hand triggers at waterhoses',
  energyReduction: 'Energy reduction',
  caseStudyResReducCalc: 'Case study resource reduction',
  targetParameter: 'Target parameter',
  otherMeasures: 'Other measures',
  impactEnergy: 'Energy impact:',
  impactWater: 'Water impact:',
  recommendations: 'Recommendations',
  filter: 'Filter',
  etpType: 'ETP Type',
  parameter: 'Parameter',
  expenditureInvestement: 'Investment',
  impact: 'Impact',
  orderby: 'Order by',
  noData: 'No data matches the selected filters',
  clearAll: 'Clear All',
  clear: 'Clear'
};
